export default __webpack_public_path__ + "73d8984dd9e6af29a01d38af04a859ae.svg";